export default __webpack_public_path__ + "static/media/FoodPanda.c05090df.png";